"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTravelEstimateType = exports.EstimateStatusName = exports.EstimateStatus = void 0;
var EstimateStatus;
(function (EstimateStatus) {
    EstimateStatus["REQUESTED"] = "requested";
    EstimateStatus["CHECK"] = "checked";
    EstimateStatus["QUOTED"] = "quoted";
    EstimateStatus["RECEIVED"] = "received";
    EstimateStatus["CONFIRMED"] = "confirmed";
    EstimateStatus["CANCELED"] = "canceled";
})(EstimateStatus || (exports.EstimateStatus = EstimateStatus = {}));
var EstimateStatusName;
(function (EstimateStatusName) {
    EstimateStatusName["requested"] = "\uC0C1\uB2F4 \uC2E0\uCCAD";
    EstimateStatusName["checked"] = "\uC5EC\uD589\uC0AC \uD655\uC778 \uBC0F \uC0C1\uB2F4";
    EstimateStatusName["quoted"] = "\uACAC\uC801\uC11C \uB3C4\uCC29";
    EstimateStatusName["received"] = "\uB2E8\uCCB4\uC5EC\uD589 \uB9DE\uCDA4 \uC0C1\uD488 \uB3C4\uCC29";
    EstimateStatusName["confirmed"] = "\uB2E8\uCCB4\uC5EC\uD589 \uC608\uC57D \uC644\uB8CC";
    EstimateStatusName["canceled"] = "\uACAC\uC801 \uCDE8\uC18C";
})(EstimateStatusName || (exports.EstimateStatusName = EstimateStatusName = {}));
var CustomTravelEstimateType;
(function (CustomTravelEstimateType) {
    CustomTravelEstimateType["SELF"] = "self";
    CustomTravelEstimateType["ADVISOR"] = "advisor";
})(CustomTravelEstimateType || (exports.CustomTravelEstimateType = CustomTravelEstimateType = {}));
